import { render, staticRenderFns } from "./TeacherTable.vue?vue&type=template&id=51bd6dc0"
import script from "./TeacherTable.vue?vue&type=script&lang=js"
export * from "./TeacherTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports